module.exports = __webpack_public_path__ + "img/p4.a57b4801.png";